export function getCurrentTimestamp() {
    return new Date().getTime();
}
//# sourceMappingURL=getCurrentTimestamp.js.map